
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login/samsung",
      function () {
        return require("private-next-pages/login/samsung.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/login/samsung"])
      });
    }
  